

export function clst(array: string[]) {
    return array.join(" ")
}